import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";

// All open positions
export const getCareer = createAsyncThunk("career/list", async (_, { rejectWithValue }) => {
  try {
    return await GET(API.GET_Career);
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

// One position
export const getCareerById = createAsyncThunk("career/byId", async (id, { rejectWithValue }) => {
  try {
    return await GET(`${API.GET_Careers}/${id}`);
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

const careerSlice = createSlice({
  name: "career",
  initialState: { addCareer: [], addCareerById: null, error: null, status: "idle" },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCareer.pending, (s) => { s.status = "loading"; s.error = null; })
      .addCase(getCareer.fulfilled, (s, a) => { s.status = "succeeded"; s.addCareer = a.payload?.data || []; })
      .addCase(getCareer.rejected, (s, a) => { s.status = "failed"; s.error = a.payload || "Could not load jobs"; })
      .addCase(getCareerById.pending, (s) => { s.status = "loading"; })
      .addCase(getCareerById.fulfilled, (s, a) => { s.status = "succeeded"; s.addCareerById = a.payload?.data || null; })
      .addCase(getCareerById.rejected, (s, a) => { s.status = "failed"; s.error = a.payload; });
  },
});

export default careerSlice.reducer;